<template>
  <panel>
    <attachments
      :schema="$schema"
      :entity-type="entityType"
      :entity-id="procedureId"
      :show-radio="false"
      :editable="editable"
      :show-add-from-mdok-button="true"
    />
  </panel>
</template>

<script>
import { mapState } from 'vuex';

import Attachments from '@/components/formComponents/attachment/Attachments';
import Panel from '@/components/panel/Panel';
import { EntityType } from '@/enums/entityType.enum';
import { formMixin } from '@/mixins/form';
import { wizardStepMixin } from '@/mixins/wizardStep';
import schema from '@/schemas/procedureAttachments.schema';

// @vuese
// Załączniki procedury
// @group Procedure
export default {
  components: { Attachments, Panel },
  schema,
  mixins: [formMixin],

  data() {
    return {
      entityType: EntityType.PROCEDURE,
      model: {}
    };
  },
  computed: {
    procedureId() {
      return this.$route.params.procedureId.toString();
    },

    ...mapState({
      attachments: state => state.procedure.attachment.list,
      editable: state => state.auth.checkPermission.permissions['PROCEDURE.UPDATE']
    })
  },
  mounted() {
    this.$schema.attachments.$setData(this.attachments);
  }
};
</script>
